import { render, staticRenderFns } from "./TermoConsentimento.vue?vue&type=template&id=7d9e30da&"
import script from "./TermoConsentimento.vue?vue&type=script&lang=js&"
export * from "./TermoConsentimento.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports